import React from "react";
import { Box, Button, Grid, LinearProgress } from "@material-ui/core";
import TextFieldHelper from "../../UI/FormHelper/TextFieldHelper";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import ChipInput from "material-ui-chip-input";

const LegalEntityAddFormFields = (props) => {
  const {
    values,
    touched,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
    handleClose,
    handleSubmit,
    errors,
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper title={"نام"} fieldName={"name"} {...props} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper title={"ایمیل"} fieldName={"email"} {...props} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"وب سایت"}
                fieldName={"website"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"کد ملی"}
                fieldName={"national_code"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره ثبت"}
                fieldName={"register_no"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <ChipInput
                value={values["phone"]}
                onChange={(e) => {
                  setFieldValue("phone", e);
                }}
                onDelete={(chip, index) => {
                  setFieldValue(
                    "phone",
                    values["phone"].filter((ch) => ch != chip),
                  );
                }}
                onAdd={(chip) => {
                  setFieldValue("phone", [...values["phone"], chip]);
                }}
                fullWidth={true}
                variant={"outlined"}
                label={"تلفن"}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <ChipInput
                value={values["mobile"]}
                onChange={(e) => {
                  setFieldValue("mobile", e);
                }}
                onDelete={(chip, index) => {
                  setFieldValue(
                    "mobile",
                    values["mobile"].filter((ch) => ch != chip),
                  );
                }}
                onAdd={(chip) => {
                  setFieldValue("mobile", [...values["mobile"], chip]);
                }}
                fullWidth={true}
                variant={"outlined"}
                label={"موبایل"}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"آدرس"}
                fieldName={"address"}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"توضیحات"}
                fieldName={"description"}
                {...props}
              />
            </Box>
          </Grid>

          {props.isEdit ? (
            <Wrapper>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ویرایش"}
                    fieldName={"updated_at"}
                    {...props}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ثبت"}
                    fieldName={"created_at"}
                    disabled={true}
                    {...props}
                  />
                </Box>
              </Grid>
            </Wrapper>
          ) : null}
        </Grid>

        <Box mt={2}>
          {props.loading ? (
            <Wrapper>
              <Button
                fullwidth={true}
                size={"large"}
                disabled={true}
                color={"default"}
              >
                در حال ارسال
              </Button>
              <LinearProgress />
            </Wrapper>
          ) : (
            <Button
              variant={"contained"}
              type="submit"
              size={"large"}
              fullWidth={true}
              color={"primary"}
            >
              {props.isEdit ? "ثبت ویرایش" : "افزودن فرد حقوقی"}
            </Button>
          )}
        </Box>
      </form>
    </div>
  );
};

export default LegalEntityAddFormFields;
